module.exports = __webpack_public_path__ + "static/ABOUT-83f15974cccfde201e0d1472dca650f7.svg";